import { render, staticRenderFns } from "./affiliator.vue?vue&type=template&id=095d952a&"
import script from "./affiliator.vue?vue&type=script&lang=js&"
export * from "./affiliator.vue?vue&type=script&lang=js&"
import style0 from "./affiliator.vue?vue&type=style&index=0&id=095d952a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzOffline: require('/opt/yamal.ru/node_modules/razlet-ui/src/components/offline/index.vue').default,RzNotificationCenter: require('/opt/yamal.ru/node_modules/razlet-ui/src/components/notification-center/index.vue').default,BaseHeader: require('/opt/yamal.ru/src/components/base/header/index.vue').default,BaseOrnamentBg: require('/opt/yamal.ru/src/components/base/ornament-bg.vue').default,BaseFooter: require('/opt/yamal.ru/src/components/base/footer.vue').default})
